import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Link } from 'react-router-dom'

@withRouter
class LoadErrorBox extends Component {

	constructor(props){
		super(props);

		this.retry = this.retry.bind(this);
	}


	retry(e) {

        e.preventDefault();
        this.props.retry();
	}


	render() {

		const currentLocation = this.props.location;

		return (
			<div className="info_none">
				<p className="txt_none">
					<span className="wrap_ico"><span className="ico_blog ico_reload"/></span>
					페이지를 불러오지 못했습니다. <br/>
				</p>
				<Link to={currentLocation} onClick={this.retry} className="link_none">다시 시도해주세요.</Link>
			</div>
		)
	}
}

export default LoadErrorBox
